/**
 * Endpoints — page « Pointeuse » (pointages, absences et heures tirés de Teams).
 * Miroir front du contrat serveur : toutes les routes sont sous `/api/pointeuse`
 * et exigent le rôle complémentaire « pointeuse ».
 */

const periodQuery = ({ du, au }) => `?du=${du}&au=${au}`

const payrollQuery = ({ mois, societe }) => {
  const query = new URLSearchParams({ mois })
  if (societe) query.set('societe', societe)
  return `?${query.toString()}`
}

export const pointeuseEndpoints = {
  etat: () => '/api/pointeuse/etat',
  actualiser: () => '/api/pointeuse/actualiser',
  periode: (range) => `/api/pointeuse/periode${periodQuery(range)}`,
  compteur: (range) => `/api/pointeuse/compteur${periodQuery(range)}`,
  exportPaie: (params) => `/api/pointeuse/export-paie${payrollQuery(params)}`,
  aTraiter: () => '/api/pointeuse/a-traiter',
  aTraiterCompte: () => '/api/pointeuse/a-traiter/compte',
  relancer: () => '/api/pointeuse/a-traiter/relancer',
  classer: () => '/api/pointeuse/a-traiter/classer',
  salaries: () => '/api/pointeuse/salaries',
  salarie: (id) => `/api/pointeuse/salaries/${encodeURIComponent(id)}`,
  parametres: () => '/api/pointeuse/parametres',
  pausePrevue: (id) => `/api/pointeuse/salaries/${encodeURIComponent(id)}/pause-prevue`
}
